import z from 'zod';

import { isoDateSchema } from './date';

export const AI_PROJECT_STATUSES = ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED', 'PAST_DUE'] as const;

export const AI_INVOICE_STATUSES = ['draft', 'sent', 'partial', 'overdue', 'paid'] as const;

export const getProjectsArgsSchema = z.object({
  businessId: z.string().optional(),
  customerId: z.string().optional(),
  status: z.enum(AI_PROJECT_STATUSES).optional(),
});

export const getInvoicesArgsSchema = z.object({
  businessId: z.string().optional(),
  customerId: z.string().optional(),
  dueAfter: isoDateSchema.optional(),
  dueBefore: isoDateSchema.optional(),
  limit: z.number().int().min(1).optional(),
  projectId: z.string().optional(),
  status: z.enum(AI_INVOICE_STATUSES).optional(),
});

export const getBusinessTransactionsArgsSchema = z.object({
  businessId: z.string(),
  customerId: z.string().optional(),
  endDate: isoDateSchema.optional(),
  includeTransfers: z.boolean().optional(),
  limit: z.number().int().min(1).optional(),
  projectId: z.string().optional(),
  startDate: isoDateSchema.optional(),
});

export const getAgingArgsSchema = z.object({
  customerId: z.string().optional(),
});

export const getTopProductsArgsSchema = z.object({
  limit: z.number().int().min(1).optional(),
});

export type GetProjectsArgs = z.infer<typeof getProjectsArgsSchema>;
export type GetInvoicesArgs = z.infer<typeof getInvoicesArgsSchema>;
export type GetBusinessTransactionsArgs = z.infer<typeof getBusinessTransactionsArgsSchema>;
